import React from 'react';
import "./Functionality.css";
import funcImg from "../../assets/function.jpg";

const Functionality = () => {
  return (
    <div className='Functionality'>
        <h3>How It Works</h3>
        <p>Getting clear, glowing skin has never been this simple.</p>
        <div className="func-cont">
            <div className="func-img">
                <img src={funcImg} alt="How It Works" />
            </div>
            <div className="func">
                <div className="fnc">
                    <h4>Scan Your Skin</h4>
                    <p>Open the app and take a quick selfie. Our AI instantly analyzes your skin—detecting concerns like acne, dark spots, and uneven tone.</p>
                </div>
                <div className="fnc">
                    <h4>Get Personalized Insights</h4>
                    <p>Within seconds, you receive a detailed skin report tailored specifically to your unique skin type and needs.</p>
                </div>
                <div className="fnc">
                    <h4>Receive Smart Recommendations</h4>
                    <p>We recommend the best skincare routine and products designed for your skin—no guessing, no trial and error.</p>
                </div>
                <div className="fnc">
                    <h4>Shop Instantly in the Marketplace</h4>
                    <p>No more searching. Purchase your recommended products directly within the app—fast, easy, and trusted.</p>
                </div>
                <div className="fnc">
                    <h4>Track Your Progress</h4>
                    <p>Monitor your skin’s improvement over time with regular scans and real-time feedback.</p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Functionality